import { render, staticRenderFns } from "./Owners.vue?vue&type=template&id=4c563d1e&scoped=true"
import script from "./Owners.vue?vue&type=script&lang=js"
export * from "./Owners.vue?vue&type=script&lang=js"
import style0 from "./Owners.vue?vue&type=style&index=0&id=4c563d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c563d1e",
  null
  
)

export default component.exports